@import '../../themes/capsule.globals';

:host {
  // CONTAINER
  --container-height: 20px;
  --container-width: 20px;
  --container-border-radius: var(--cpsl-border-radius-checkbox);
  --container-border-width: 2px;
  --container-background-color-default: var(--cpsl-color-checkbox-surface-default);
  --container-border-color-default: var(--cpsl-color-checkbox-border-default);
  --container-background-color-checked: var(--cpsl-color-checkbox-surface-checked);
  --container-border-color-checked: var(--cpsl-color-checkbox-border-checked);

  // ICON
  --icon-height: 16px;
  --icon-width: 16px;
  --checkbox-icon-color: var(--cpsl-color-checkbox-icon);

  display: block;
  position: relative;

  height: var(--container-height);
  width: var(--container-width);
  cursor: pointer;
}

input {
  position: absolute;
  width: 100%;
  height: 100%;
  margin: 0px;
  opacity: 0;
}

span.container {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  border-radius: var(--container-border-radius);
  border: var(--container-border-width) solid;
  background: var(--container-background-color-default);
  border-color: var(--container-border-color-default);

  transition: all 0.15s ease-in-out;

  cpsl-icon {
    --height: var(--icon-height);
    --width: var(--icon-width);
    opacity: 0;
    --icon-color: var(--checkbox-icon-color);
    transition: all 0.15s ease-in-out;
  }

  &.checked {
    background: var(--container-background-color-checked);
    border-color: var(--container-border-color-checked);

    cpsl-icon {
      opacity: 1;
    }
  }
}
